<template>
  <div class="text-center">
    <b-card style="width:50vw" class="ml-auto mr-auto">

        <h5>{{value}}</h5>
    </b-card>

  </div>
</template>

<script>
import axios from 'axios'
export default {
   name:'VerifyAccount',
   data(){
     return {
       isSuccess:false,
       value:'Verifying your account'
     }
   },
   created(){
       console.log(this.$route.params)
       if(this.$route.params.id!=null){
         console.log("came")
         this.verifyAccount()
       }
       else{
         console.log("not came")

       }
   },
   methods:{
       async verifyAccount(){
         let self=this
         console.log("dobule ducker")
        axios.post('https://us-central1-provider-admin-panel.cloudfunctions.net/verifyUser', {
        uid: this.$route.params.id,
        })
        .then(response => {
          console.log(response)
          

          self.value='Account verified'
          setTimeout(() => {
            
          this.$router.push('/login')
          }, 2000);

        })
        .catch(error=>{
          console.log(error)
          self.value='Error verifying'

        })
       }
   } 

}
</script>

<style>

</style>